module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/bfb4e4698a86df5f18d0bc345580142e.png";